const SENSITIVE_KEY = /secret|token|password|signature|pan|cvv|pin|credential/i;

/** Metadata may be nested; masking only top-level keys leaks nested secrets. */
export function redactSensitive(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(redactSensitive);
  if (value && typeof value === "object") {
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [
      key, SENSITIVE_KEY.test(key) ? "••••••" : redactSensitive(item),
    ]));
  }
  return value;
}
